//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { ColumnModel } from '../../modules/api/api.models'

import { Enums } from '../../models/common'
import { OpRoute, OpOperator } from '../../models/core'

import { ToastHelper, LocalizationHelper } from '../../helpers'

import { GRID_SERVICE_NAME, GridService } from '../grid'
import { SYSTEM_SERVICE_NAME, SystemService } from '../system'

import { RouteService, ROUTE_SERVICE_NAME } from './route.service'


//#region Public Types

export const ROUTE_OPERATORS_SERVICE_NAME = 'RouteOperatorsService'
export const ROUTE_OPERATORS_SERVICE_PROVIDER_NAME = 'RouteOperatorsServiceProvider'

//#endregion


export class RouteOperatorService {

    //#region Costs

    public static get LOG_PREFIX(): string { return '[SIMAX.Services.Route.Operators]' }

    //#endregion


    //#region Ctor

    constructor(
        private gridService: GridService,
        private routeService: RouteService,
        private systemService: SystemService
    ) { }

    //#endregion


    //#region Columns

    public getOperatorGridColumns(route: OpRoute): JQueryPromise<ColumnModel[]> {
        return this.gridService.getColumnModelByCategory(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__OPERATOR_GRID_PARAMS, RouteService.SIMAX_MODULE_NAME, {
            groupReferenceType: Enums.ReferenceType.IdDistributor,
            groupReferenceValue: route.idDistributor,
            viewReferenceType: Enums.ReferenceType.IdOperator
        })
    }

    //#endregion


    //#region Edit

    public getOperatorGridEditObjectsFromRoute(route: OpRoute): any[] {
        return _.map(route.operatorList, (operator: OpOperator) => {
            const gridObject = this.gridService.gridObjectFromIOpObject(operator)

            gridObject.id = operator.idOperator

            return gridObject
        })
    }

    //#endregion


    //#region Save

    public saveOperatorsToRoute(route: OpRoute, addedOperators: OpOperator[], removedOperators: OpOperator[]): JQueryPromise<OpRoute> {
        const routeToSave: OpRoute = route.clone()

        routeToSave.opState = Enums.OpChangeState.Modified
        routeToSave.operatorList = []

        if (route.operatorExecutor != null) {
            routeToSave.operatorExecutor = route.operatorExecutor.clone()

            if (route.operatorExecutor.actor) {
                routeToSave.operatorExecutor.actor = route.operatorExecutor.actor.clone()
                routeToSave.operatorExecutor.actor.avatar = null
            }
        }

        _.forEach(addedOperators, (addedOperator: OpOperator) => {
            const clonedOperator: OpOperator = addedOperator.clone()

            clonedOperator.opState = Enums.OpChangeState.New

            const operatorExists: boolean = _.find(route.operatorList, (operator: OpOperator) => {
                operator.idOperator === clonedOperator.idOperator
            }) != null

            if (!operatorExists) {
                routeToSave.operatorList.push(clonedOperator)
            }
        })

        _.forEach(removedOperators, (removedOperator: OpOperator) => {
            const clonedOperator: OpOperator = removedOperator.clone()

            clonedOperator.opState = Enums.OpChangeState.Delete

            routeToSave.operatorList.push(clonedOperator)
        })

        const removedOperatorIds: number[] = removedOperators.map((removedOperator: OpOperator) => removedOperator.idOperator)

        route.operatorList
            .filter((loadedOperators: OpOperator) => !_.include([...removedOperatorIds], loadedOperators.idOperator))
            .forEach((loadedOperators: OpOperator) => {
                const clonedTechnicalPermission: OpOperator = loadedOperators.clone()

                clonedTechnicalPermission.opState = Enums.OpChangeState.Loaded

                routeToSave.operatorList.push(clonedTechnicalPermission)
            })

        if (_.size(addedOperators) > 0 || _.size(removedOperators)) {
            return this.routeService.saveRoute(routeToSave)
        }

        return $.Deferred().resolve(route).promise()
    }

    public saveOperatorsGridEditResult(route: OpRoute, grid: any[]): JQueryPromise<OpRoute> {
        const addedOperators: OpOperator[] = []
        const removedOperators: OpOperator[] = []
        let isOperatorExecutorRemoved: boolean = false

        _.forEach(grid, (gridItem: any) => {
            if (gridItem.isNew) {
                const operatorToAdd: OpOperator = new OpOperator(null)

                operatorToAdd.idOperator = gridItem.id

                addedOperators.push(operatorToAdd)
            }
        })

        _.forEach(grid, (gridItem: any) => {
            if (gridItem.isRemoved) {
                const operatorToRemove: OpOperator = new OpOperator(null)

                operatorToRemove.idOperator = gridItem.id

                if (operatorToRemove.idOperator != route.idOperatorExecutor) {
                    removedOperators.push(operatorToRemove)
                } else {
                    isOperatorExecutorRemoved = true
                }
            }
        })

        if (isOperatorExecutorRemoved) {
            const operatorExecutorString: string | number = route.operatorExecutor != null ? route.operatorExecutor.toString() : route.idOperatorExecutor

            ToastHelper.showWarning(`${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.CantDeleteExecutOperator)}: ${operatorExecutorString}`)
        }

        return this.saveOperatorsToRoute(route, addedOperators, removedOperators)
    }

    //#endregion


    //#region Options

    public openOperatorDetails(idOperator: number, pageOperatorIds: number[]) {
        this.systemService.openDetails({
            moduleName: Enums.SimaxModuleName.Operator,
            referenceObjectId: idOperator,
            pageItemsIds: pageOperatorIds
        })
    }

    //#endregion
}

export class RouteOperatorServiceProvider implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [
        GRID_SERVICE_NAME,
        ROUTE_SERVICE_NAME,
        SYSTEM_SERVICE_NAME,
        function (gridService: GridService, routeService: RouteService, systemService: SystemService) {
            return new RouteOperatorService(gridService, routeService, systemService)
        }]

    //#endregion
} 